var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGi12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2H1V0H17V2ZM16.5 11H15V16L18.61 18.16L19.36 16.94L16.5 15.25V11ZM23 15C23 18.87 19.87 22 16 22C12.47 22 9.57 19.39 9.08 16H1V10H0V8L1 3H17L18 8V8.29C20.89 9.16 23 11.83 23 15ZM3 14H9V10H3V14ZM21 15C21 12.24 18.76 10 16 10C13.24 10 11 12.24 11 15C11 17.76 13.24 20 16 20C18.76 20 21 17.76 21 15Z",
    fill: "#292929",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGi12);
export default __webpack_public_path__ + "static/media/gi-12.20872472f0ed660207fde44f9f842537.svg";
export { ForwardRef as ReactComponent };